import React from 'react';
import styled from '@emotion/styled';
import withTranslation from '../../../../hoc/withTranslation';
import Label from '../../../Form/Label';
import { StyledSelectBigInput, StyledDoublePanel } from '../../Global/WizardStyled';
import { colors } from '../../../../global/variables';

const { primaryBorderColor } = colors;

const StyledEVSelect = styled(StyledSelectBigInput)`
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #f5f5f5;
    color: #999;

    &:hover {
      border-color: ${primaryBorderColor};
    }
  }
`;

const StyledVariantWrapper = styled.div`
  margin-top: 1rem;
`;

const EVDropdowns = ({
  makes,
  models,
  variants,
  selectedMake,
  selectedModel,
  selectedVariant,
  onMakeChange,
  onModelChange,
  onVariantChange,
  translations: {
    wizard: {
      fleet: {
        evMakeLabel,
        evModelLabel,
        evVariantLabel,
        evMakePlaceholder,
        evModelPlaceholder,
        evVariantPlaceholder,
      },
    },
  },
}) => {
  return (
    <>
      <StyledDoublePanel>
        <div>
          <Label>{evMakeLabel}</Label>
          <StyledEVSelect fullWidth onChange={onMakeChange} value={selectedMake} id="input-ev-make">
            <option value="">{evMakePlaceholder}</option>
            {makes.map((make) => (
              <option key={make.id} value={make.id}>
                {make.name}
              </option>
            ))}
          </StyledEVSelect>
        </div>
        <div>
          <Label>{evModelLabel}</Label>
          <StyledEVSelect
            fullWidth
            onChange={onModelChange}
            value={selectedModel}
            id="input-ev-model"
            disabled={!selectedMake}
          >
            <option value="">{evModelPlaceholder}</option>
            {models.map((model) => (
              <option key={model.id} value={model.id}>
                {model.name}
              </option>
            ))}
          </StyledEVSelect>
        </div>
      </StyledDoublePanel>

      <StyledVariantWrapper>
        <Label>{evVariantLabel}</Label>
        <StyledEVSelect
          fullWidth
          onChange={onVariantChange}
          value={selectedVariant}
          id="input-ev-variant"
          disabled={!selectedMake || !selectedModel}
        >
          <option value="">{evVariantPlaceholder}</option>
          {variants.map((variant) => {
            const displayName = variant.versions?.[0]?.label
              ? `${variant.versions[0].label} (${variant.releaseYear})`
              : `Profile ${variant.profileId} (${variant.releaseYear})`;
            return (
              <option key={variant.profileId} value={variant.profileId}>
                {displayName}
              </option>
            );
          })}
        </StyledEVSelect>
      </StyledVariantWrapper>
    </>
  );
};

export default withTranslation(EVDropdowns);
